// @flow
import { theme } from "../theme";

type FillStyle = {
  background: string,
  colour: string,
};

type Style = {
  marginTop?: string,
  margintLeft?: string,
};

type HousePinProps = {
  fillStyle?: FillStyle,
  width?: string,
  height?: string,
  style?: Style,
};

const defaultFillStyle = {
  background: theme.palette.peachy.medium,
  colour: theme.palette.navy.medium,
};

export const HousePin = ({
  fillStyle = defaultFillStyle,
  style = {},
  width = "64",
  height = "64",
}: HousePinProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 64 64"
    style={style}
  >
    <g fill="none" fillRule="evenodd">
      <rect width="64" height="64" />
      <path
        fill={fillStyle?.background}
        fillRule="nonzero"
        d="M15.81571,46.4781252 C10.8113864,41.4736286 8,34.6863322 8,27.609308 L8,27.152108 C8,18.2570404 13.199066,10.1828758 21.2968825,6.50204217 L22.0687308,6.15121658 C28.3789198,3.28293518 35.6211596,3.28292876 41.9311982,6.1511916 C50.4991379,10.045666 56,18.5884998 56,27.999908 L56,28.438908 C56,34.9849255 53.3996973,41.2626378 48.7710136,45.8913216 L36.2426136,58.4197216 C33.8995665,60.7627687 30.1004435,60.7627687 27.75737,58.4197252 L15.81571,46.4781252 Z"
      />
      <path
        fill={fillStyle?.colour}
        fillRule="nonzero"
        d="M22,22.03623 L22,17 C22,16.4477153 22.4477153,16 23,16 L27,16 C27.5522847,16 28,16.4477153 28,17 L28,17.6725936 L31.4118283,15.1912639 C31.7624788,14.9362454 32.2375212,14.9362454 32.5881717,15.1912639 L42.7645151,22.5922409 C43.5407479,23.1567739 44,24.0586394 44,25.0184492 L44,40 C44,40.5522847 43.5522847,41 43,41 L21,41 C20.4477153,41 20,40.5522847 20,40 L20,25.0184492 C20,24.0586394 20.4592521,23.1567739 21.2354849,22.5922409 L22,22.03623 Z M24,20.5816845 L26,19.127139 L26,18 L24,18 L24,20.5816845 Z M36,39 L42,39 L42,25.0184492 C42,24.6985126 41.846916,24.3978907 41.5881717,24.2097131 L32,17.2364973 L22.4118283,24.2097131 C22.153084,24.3978907 22,24.6985126 22,25.0184492 L22,39 L28,39 L28,30 C28,29.4477153 28.4477153,29 29,29 L35,29 C35.5522847,29 36,29.4477153 36,30 L36,39 Z M34,39 L34,31 L30,31 L30,39 L34,39 Z"
      />
    </g>
  </svg>
);
